export class UploadInfo {
    constructor(companyid, fielddetails,totalpage, documenttype,filedata) {
      this.companyid = companyid;
      this.fielddetails = fielddetails;
      this.totalpage = totalpage;
      this.documenttype=documenttype;
      this.filedata=filedata;
    }
  }
  